// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\niframe[data-v-5a2fda51] {\n  width: 100%;\n  border: none;\n}\n.high[data-v-5a2fda51] {\n  min-height: 80vh;\n}\n", ""]);
// Exports
module.exports = exports;
